import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ENavigationRoute } from '../model/enum/navigation-route';
import { CoreData } from './core-data/core-data';
import { EUserType } from '../domain/enum/user-type';
import { environment } from 'src/environments/environment';
import { ENavigationErrorType } from '../model/enum/navigation-error-type';

@Injectable()
export class LoginGuard  {
    constructor(private router: Router,
        private coreData: CoreData) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

        const url = route.url[0] === undefined ? ENavigationRoute.Home : route.url[0].path;
        if (this.coreData.User !== undefined && !this.hasPermission(url))
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.UnAuthorized }])
        return (this.coreData.User !== undefined && this.coreData.IsLoggedIn) || this.router.parseUrl(ENavigationRoute.Login);
        // return (this.coreData.User !== undefined && this.coreData.IsLoggedIn && this.hasPermission(url));
    }

    hasPermission(url: string) {
        if (this.coreData.UserType === EUserType.None) {
            return false; 
        }
        switch (url) {
            case ENavigationRoute.Config:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.ConfigList:
                if (this.coreData.User && this.coreData.User.Type !== EUserType.Standard) {
                    return true;
                }
                break;
            case ENavigationRoute.LimitSettings:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.SampleList:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.TestManagement:
                if (this.coreData.User) {
                    return true;
                }
                break;
            case ENavigationRoute.User:
                if (this.coreData.User && this.coreData.User.Type === EUserType.Administrateur) {
                    return true;
                }
                break;
        }
        return false;
    }
}

